import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Bot, UserRound, Wrench } from "lucide-react";
import { cn } from "@/lib/utils";

const TOOL_LABEL = { list_employees: "Resolving employees", get_data_coverage: "Checking data coverage", get_day_overview: "Loading day overview", get_employee_day: "Loading employee day", get_events: "Fetching events", find_idle_gaps: "Finding idle gaps", compare_weekly: "Comparing weeks", get_task: "Loading task" };

export function ToolChips({ tools = [] }) {
  if (!tools.length) return null;
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="tool-chips">
      {tools.map((t, i) => <span key={i} className={cn("inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-semibold", t.status === "start" ? "border-blue-200 bg-blue-50 text-blue-700 animate-pulse" : t.error ? "border-rose-200 bg-rose-50 text-rose-700" : "border-slate-200 bg-slate-50 text-slate-600")} data-testid={`tool-chip-${t.name}`}><Wrench className="h-3 w-3" />{TOOL_LABEL[t.name] || t.name}{t.args?.date ? ` · ${t.args.date}` : t.args?.week_start ? ` · wk ${t.args.week_start}` : ""}</span>)}
    </div>
  );
}

export function ChatMessage({ m }) {
  const mine = m.role === "user";
  return (
    <div className={cn("flex gap-3", mine && "flex-row-reverse")} data-testid={`chat-message-${m.role}`}>
      <div className={cn("mt-0.5 grid h-8 w-8 shrink-0 place-items-center rounded-full", mine ? "bg-slate-200 text-slate-700" : "bg-[#101C47] text-white")}>{mine ? <UserRound className="h-4 w-4" /> : <Bot className="h-4 w-4" />}</div>
      <div className={cn("max-w-[85%] space-y-2", mine && "text-right")}>
        {!mine && <ToolChips tools={m.tools || []} />}
        {m.content != null && m.content !== "" && (
          <div className={cn("rounded-2xl px-4 py-3 text-sm leading-relaxed text-left", mine ? "bg-[#101C47] text-white rounded-tr-sm" : "bg-white border border-slate-200 rounded-tl-sm shadow-sm")}>
            {mine ? <div className="whitespace-pre-wrap">{m.content}</div> : <div className="tqi-prose"><ReactMarkdown remarkPlugins={[remarkGfm]}>{m.content}</ReactMarkdown></div>}
          </div>
        )}
        {m.streaming && !m.content && <div className="text-xs text-slate-500 animate-pulse" data-testid="chat-thinking">Thinking…</div>}
        {m.error && <div className="rounded-md border border-rose-200 bg-rose-50 px-3 py-2 text-left text-xs text-rose-700" data-testid="chat-error">{m.error}</div>}
      </div>
    </div>
  );
}
